import { render, staticRenderFns } from "./traceModule.vue?vue&type=template&id=b72d4c68"
import script from "./traceModule.vue?vue&type=script&lang=js"
export * from "./traceModule.vue?vue&type=script&lang=js"
import style0 from "./traceModule.vue?vue&type=style&index=0&id=b72d4c68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports